import type { CalendarItem } from '@efdigital/ll-addon-data';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditCalendarItem } from '@efdigital/ll-admin-v2/components/programs/calendar/edit-calendar-item';
import { findCalendarItem } from '@efdigital/ll-admin-v2/data/builders/xceed/calendar-items';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type ProgramsProgramCohortCalendarItemRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort/calendar/calendar-item';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { Store } from '@warp-drive/core';
import { cacheKeyFor } from '@warp-drive/core';
import { Request } from '@warp-drive/ember';
import { serializePatch } from '@warp-drive/utilities/json-api';
import { updateRecord } from '@warp-drive/utilities/json-api';
import { pageTitle } from 'ember-page-title';

interface CalendarItemSignature {
  Args: {
    model: ModelFrom<ProgramsProgramCohortCalendarItemRoute>;
    controller: unknown;
  };
}

export default class ProgramsProgramCohortCalendarItemTemplate extends Component<CalendarItemSignature> {
  @service declare store: Store;

  updateCalendarItem = (
    currentCalendarItem: CalendarItem,
    updates: Partial<CalendarItem>
  ) => {
    Object.assign(currentCalendarItem, updates);

    const init = updateRecord(currentCalendarItem, {
      ...jsonApiOptions,
      patch: true,
    });
    init.body = JSON.stringify(
      serializePatch(this.store.cache, cacheKeyFor(currentCalendarItem))
    );
    init.headers.set('Content-Type', 'application/vnd.api+json');

    return this.store.request(init);
  };

  <template>
    <div class="container py-5">
      {{pageTitle "Index"}}
      <EditContext as |context|>
        <Request @query={{findCalendarItem @model.calendar_item_id}}>
          <:content as |content|>
            <div class="row">
              <EditCalendarItem
                @item={{content.data}}
                @context={{context}}
                class="col-md-8 mx-auto"
              />
            </div>
          </:content>
        </Request>
      </EditContext>
    </div>
  </template>
}
